import React from 'react';
import { availableLanguages } from '../components/common/webSiteLanguages';
import { useGlobalData } from '../providers/globalDataProvider/globalDataProvider.useGlobalData';

export const useAlternateUrl = (baseUrl) => {
  const {
    activeComponent,
    country: currentCountry,
    language: currentLanguage,
  } = useGlobalData();

  return availableLanguages.map((element) => {
    const { languages, country, links } = element;
    return languages.map((language) => {
      const config = links.find((link) => link.component === activeComponent);
      if (
        config &&
        (currentCountry !== country || currentLanguage !== language)
      ) {
        const link = `${baseUrl}/${country}/${language}/${
          config[`slug_${language}`]
        }`;
        return (
          <link
            rel="alternate"
            href={link}
            hrefLang={language}
            key={`${country}_${language}`}
          />
        );
      }
      return null;
    });
  });
};

export default useAlternateUrl;
